import React from 'react';

import { Divider } from '@lyearn/ui';
import { SidebarItems, SideBarMode } from '@/modules/corporate/modules/admin/hooks/useSidebar';

import SidebarFlyoutProvider from './FlyoutPanel/context';
import Section from './Section';

const SidebarItem = ({
  sidebarItems,
  mode,
  className,
}: {
  sidebarItems: SidebarItems;
  mode?: SideBarMode;
  className?: string;
}) => {
  return (
    <SidebarFlyoutProvider>
      {sidebarItems.map((section, index) => (
        <React.Fragment key={section.id}>
          {/* mt-10, not mt-16: the row above already carries a 6px bottom margin, and the
              spec wants 16px of clear space on each side of the rule. */}
          {index > 0 ? <Divider className="mx-8 mb-16 mt-10 flex-shrink-0" /> : null}
          <Section className={className} mode={mode} section={section} />
        </React.Fragment>
      ))}
    </SidebarFlyoutProvider>
  );
};

export default React.memo(SidebarItem);
